module.exports = __webpack_public_path__ + "static/media/12.ab945b1b.JPG";